export default __webpack_public_path__ + "static/media/BUL.70f96132.svg";